
export const APP_VERSION = '1.0.5';
export const APP_VERSION_DEV = '1.0.3';
export const BUILD_DATE = '08-09-2026 09:35:27';
export const BUILD_NUMBER = '080920260935';
